import { ReactElement } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import type { PlanTable } from 'src/domain/planTables/types'

interface TableRowProps {
  planTable: PlanTable
  selected: boolean
  onSelect: (id: string) => void
}

const TableRow = ({ planTable, selected, onSelect }: TableRowProps): ReactElement => {
  const theme = useTheme()

  return (
    <Box
      data-cy={`plan-table-row-${planTable.id}`}
      onClick={() => onSelect(planTable.id)}
      sx={{
        px: 1,
        py: 0.75,
        cursor: 'pointer',
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: selected ? theme.palette.action.selected : 'transparent',
        '&:hover': {
          backgroundColor: selected ? theme.palette.action.selected : theme.palette.action.hover,
        },
      }}
    >
      <Typography variant="body2" sx={{ fontSize: 13 }}>
        {planTable.name}
      </Typography>
    </Box>
  )
}

export default TableRow
